import { useState } from "react";
import { useNavigate } from "react-router-dom";
import service from "../../services/service";
import endpoints from "../../services/endpoints";
import "./Login.css";
import { BackArw } from "../../assests/ExportImageIcon";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await service.post(endpoints.auth.sendotp, { email });
      navigate("/otp", { state: { email } });
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="backArw" onClick={() => navigate("/")}>
          <img src={BackArw} />
        </div>
        <div className="login-title">Forgot your password?</div>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Email ID</label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(""); }}
              placeholder="Enter your email"
              required
            />
          </div>

          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="commonOrngBtn" disabled={loading}>
            {loading ? "Sending OTP..." : "Send OTP"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
